interface PasswordChangedModalProps {
  onConfirm: () => void
}

export default function PasswordChangedModal({ onConfirm }: PasswordChangedModalProps) {
  return (
    <div className="modal-overlay" style={{ zIndex: 10001 }}>
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <h2 style={{ textAlign: 'center', width: '100%' }}>
            Hasło zostało zmienione
          </h2>
        </div>
        
        <div className="modal-body">
          <p style={{ 
            margin: '0 0 20px 0', 
            fontSize: '15px',
            lineHeight: '1.6',
            color: '#333',
            textAlign: 'center'
          }}>
            Administrator zmienił hasło dostępu do konfiguratora.
          </p>
          
          <p style={{ 
            margin: '0 0 20px 0', 
            fontSize: '15px',
            lineHeight: '1.6',
            color: '#333',
            textAlign: 'center'
          }}>
            Musisz zalogować się ponownie używając nowego hasła.
          </p>

          <div style={{
            padding: '15px',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px',
            marginBottom: '20px',
            fontSize: '14px',
            color: '#666',
            lineHeight: '1.6'
          }}>
            <p style={{ margin: '0 0 10px 0', fontWeight: '500', color: '#333' }}>
              Co dalej?
            </p>
            <ul style={{ margin: '0', paddingLeft: '20px' }}>
              <li style={{ marginBottom: '8px' }}>Skontaktuj się z administratorem, aby uzyskać nowe hasło</li>
              <li style={{ marginBottom: '8px' }}>Po kliknięciu przycisku zostaniesz przeniesiony do ekranu logowania</li>
              <li>Zaloguj się używając nowego hasła</li>
            </ul>
          </div>
        </div>

        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
          <button
            onClick={onConfirm}
            className="btn-primary"
            style={{
              padding: '12px 40px',
              fontSize: '15px',
              fontWeight: '500',
              cursor: 'pointer',
              borderRadius: '0',
            }}
          >
            Przejdź do logowania
          </button>
        </div>
      </div>
    </div>
  )
}
